import { AddEdit } from '../../../../../interfaces/property.interface';
import { Validation } from '../../../../../interfaces/common';
import { APP_ERROR_MESSAGES, VALIDATION_FIELD_MAPPING, Regex, MaxLength, DISTANCE_FROM_LOCATION } from '../../../../../utils/appConstant';

export const validateAddEditForm = (formData: AddEdit, fieldToValidate?: string) => {
  const validations: Validation = { validate: true, fields: [] };

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.customer) {
    if (!formData.customer) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.customer,
        message: APP_ERROR_MESSAGES.property.addEdit.blankCustomer
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.name) {
    if (!formData.name?.trim()) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.name,
        message: APP_ERROR_MESSAGES.property.addEdit.blankPropertyName
      });
    } else if (formData.name.trim().length > MaxLength.common) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.name,
        message: APP_ERROR_MESSAGES.property.addEdit.maxLengthExceeded
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.publicName) {
    if (!formData.publicName?.trim()) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.publicName,
        message: APP_ERROR_MESSAGES.property.addEdit.blankPublicName
      });
    } else if (formData.publicName.trim().length > MaxLength.common) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.publicName,
        message: APP_ERROR_MESSAGES.property.addEdit.maxLengthExceeded
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.pictureUrl) {
    if (formData.pictureUrl && formData.pictureUrl.trim().length > MaxLength.pictureUrl) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.pictureUrl,
        message: APP_ERROR_MESSAGES.property.addEdit.pictureUrlMaxLengthExceeded
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.hospitableId) {
    if (formData.hospitableId && formData.hospitableId.trim().length > MaxLength.common) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.hospitableId,
        message: APP_ERROR_MESSAGES.property.addEdit.maxLengthExceeded
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.managedBy) {
    if (!formData.managedBy) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.managedBy,
        message: APP_ERROR_MESSAGES.property.addEdit.blankManagedBy
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.whoCollectsMoney) {
    formData.propertyWhoCollects.forEach(formDataInnerObj => {
      if (!formDataInnerObj?.whoCollectsMoney && formDataInnerObj?.checked) {
        validations.validate = false;
        validations.fields.push({
          field: VALIDATION_FIELD_MAPPING.whoCollectsMoney,
          message: APP_ERROR_MESSAGES.property.addEdit.blankWhoCollectsMoney,
          platformId: formDataInnerObj?.platformId
        });
      }
    })
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.whoCollectsHst) {
    formData.propertyWhoCollects.forEach(formDataInnerObj => {
      if (!formDataInnerObj?.whoCollectsHst && formDataInnerObj?.checked) {
        validations.validate = false;
        validations.fields.push({
          field: VALIDATION_FIELD_MAPPING.whoCollectsHst,
          message: APP_ERROR_MESSAGES.property.addEdit.blankWhoCollectsHst,
          platformId: formDataInnerObj?.platformId
        });
      }
    })
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.matManagedBy) {
    formData.propertyWhoCollects.forEach(formDataInnerObj => {
      if (!formDataInnerObj?.matManagedBy && formDataInnerObj?.checked && formData.configureMatTax) {
        validations.validate = false;
        validations.fields.push({
          field: VALIDATION_FIELD_MAPPING.matManagedBy,
          message: APP_ERROR_MESSAGES.property.addEdit.blankMatManagedBy,
          platformId: formDataInnerObj?.platformId
        });
      }
    })
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.cleaningManagedBy) {
    if (!formData.cleaningManagedBy) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.cleaningManagedBy,
        message: APP_ERROR_MESSAGES.property.addEdit.blankCleaningManagedBy
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.address1) {
    if (!formData.address1?.trim()) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.address1,
        message: APP_ERROR_MESSAGES.property.addEdit.blankAddress
      });
    } else if (formData.address1.trim().length > MaxLength.common) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.address1,
        message: APP_ERROR_MESSAGES.property.addEdit.maxLengthExceeded
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.address2) {
    if (formData.address2 && formData.address2.trim().length > MaxLength.common) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.address2,
        message: APP_ERROR_MESSAGES.property.addEdit.maxLengthExceeded
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.city) {
    if (!formData.city) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.city,
        message: APP_ERROR_MESSAGES.property.addEdit.blankCity
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.state) {
    if (!formData.state) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.state,
        message: APP_ERROR_MESSAGES.property.addEdit.blankState
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.postal) {
    if (!formData.postal?.trim()) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.postal,
        message: APP_ERROR_MESSAGES.property.addEdit.blankPostcode
      });
    } else if (formData.postal.trim().length > MaxLength.common) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.postal,
        message: APP_ERROR_MESSAGES.property.addEdit.maxLengthExceeded
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.country) {
    if (!formData.country) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.country,
        message: APP_ERROR_MESSAGES.property.addEdit.blankCountry
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.bookingType) {
    if (!formData.bookingType) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.bookingType,
        message: APP_ERROR_MESSAGES.property.addEdit.blankBookingType
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.distanceFromLocation) {
    if (!formData.distanceFromLocation) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.distanceFromLocation,
        message: APP_ERROR_MESSAGES.property.addEdit.blankDistanceFromLocation
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.convenienceFee) {
    if (formData.distanceFromLocation === DISTANCE_FROM_LOCATION.between50And100Km) {
      const raw = formData.convenienceFee as any;
      const str = raw?.toString?.().trim?.() ?? '';

      if (!str) {
        validations.validate = false;
        validations.fields.push({
          field: VALIDATION_FIELD_MAPPING.convenienceFee,
          message: APP_ERROR_MESSAGES.property.addEdit.blankConvenienceFee
        });
      } else if (!Regex.floatValues.test(str) || parseFloat(str) <= 0) {
        validations.validate = false;
        validations.fields.push({
          field: VALIDATION_FIELD_MAPPING.convenienceFee,
          message: APP_ERROR_MESSAGES.property.addEdit.invalidConvenienceFee
        });
      }
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.matTaxPercentage) {
    if (formData.configureMatTax) {
      const raw = formData.matTaxPercentage as any;
      const str = raw?.toString?.().trim?.() ?? '';

      if (!str) {
        validations.validate = false;
        validations.fields.push({
          field: VALIDATION_FIELD_MAPPING.matTaxPercentage,
          message: APP_ERROR_MESSAGES.property.addEdit.blankMatTaxPercentage
        });
      } else {
        if (!Regex.percentPattern.test(str)) {
          validations.validate = false;
          validations.fields.push({
            field: VALIDATION_FIELD_MAPPING.matTaxPercentage,
            message: APP_ERROR_MESSAGES.property.addEdit.invalidMatTaxPercentage
          });
        } else {
          const numValue = parseFloat(str);
          if (Number.isNaN(numValue) || numValue < 0 || numValue > 100) {
            validations.validate = false;
            validations.fields.push({
              field: VALIDATION_FIELD_MAPPING.matTaxPercentage,
              message: APP_ERROR_MESSAGES.property.addEdit.invalidMatTaxPercentage
            });
          }
        }
      }
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.commissionPercentage) {
    const raw = formData.commissionPercentage as any;
    const str = raw?.toString?.().trim?.() ?? '';

    if (!str) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.commissionPercentage,
        message: APP_ERROR_MESSAGES.property.addEdit.blankCommissionPercentage
      });
    } else {
      if (!Regex.percentPattern.test(str)) {
        validations.validate = false;
        validations.fields.push({
          field: VALIDATION_FIELD_MAPPING.commissionPercentage,
          message: APP_ERROR_MESSAGES.property.addEdit.invalidCommissionPercentage
        });
      } else {
        const numValue = parseFloat(str);
        if (Number.isNaN(numValue) || numValue < 0 || numValue > 100) {
          validations.validate = false;
          validations.fields.push({
            field: VALIDATION_FIELD_MAPPING.commissionPercentage,
            message: APP_ERROR_MESSAGES.property.addEdit.invalidCommissionPercentage
          });
        }
      }
    }
  }

  if (!fieldToValidate) {
    if ((formData.propertyWhoCollects.length === 0) || (formData.propertyWhoCollects.every(item => !item.checked))) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.maintenanceDetails,
        message: APP_ERROR_MESSAGES.property.addEdit.blankMaintenanceDetails
      });
    }
  }

  return validations;
};